import React from 'react';
import { useNavigate } from 'react-router-dom';

const FinalCtaSection = () => {
  const navigate = useNavigate();
  return (
    <section className="gh-section gh-final">
      <div className="gh-section__inner gh-final__inner">
        <h2 className="gh-final__title">One Solution. Complete Connectivity.</h2>
        <p className="gh-final__sub">
          Building smarter energy infrastructure for a more connected Africa.
        </p>
        <button className="btn btn--primary gh-final__cta" onClick={() => navigate('/gridx')}>
          Explore GRIDx
        </button>
      </div>
    </section>
  );
};

export default FinalCtaSection;
